---
en:
  market_outlook:
    duration: Duration curve
    forward_contracts: Forward contracts
    futures_prices_ytd: Futures prices YTD
    heading: Market outlook
    high: P95
    info_text: The Excel file contains all price areas, not just the selected ones.
    lowerq: Lower quartile
    median: Median
    minimum: P5
    nasim: Not possible to simulate prices for the price area at the moment
    pfc: Price Forward Curve
    pfc_table: Price Forward Table
    simulations: Price simulations
    spot_prices_ytd: Power prices YTD
    upperq: Upper quartile
